<template>
  <div
    class="agreement"
    :style="($env && $env.inMiniProgram) ? { paddingTop: (statusBarHeight + 60) + 'px' } : {}"
  >
    <!-- 微信小程序 web-view：左上角返回按钮（不影响 App 内嵌 H5） -->
    <button
      v-if="$env && $env.inMiniProgram"
      class="mp-back-btn-fixed-left"
      :style="{ top: (statusBarHeight + 12) + 'px' }"
      @click="goBackMiniProgram"
    >
      <i class="el-icon-arrow-left"></i>
    </button>
    <div class="main">
      <h2>大救星健康版用户隐私条款</h2>
      <p>
        更新日期：
        <span>2023</span>
        年
        <span>11</span>
        月
        <span>20</span>
        日
        <span></span>
      </p>
      <p>
        生效日期：
        <span>2023</span>
        年
        <span>11</span>
        月
        <span>20</span>
        日
        <span></span>
      </p>
      <p>
        尊敬的大救星健康版用户
        <span>:</span>
        大救星（江泰救援服务有限公司
        <span>,</span>
        以下亦称
        <b>
          <span>"</span>
          大救星
          <span>"</span>
        </b>
        或
        <b>
          <span>"</span>
          我们
          <span>"</span>
        </b>
        <span>)</span>
        非常重视客户个人信息及隐私权的保护
        <span>,</span>
        因此我们制订了涵盖如何收集、存储、使用、共享和保护客户信息的隐私政策。
        <b>
          《大救星健康版用户隐私条款》
          <span>(</span>
          以下简称“本隐私政策”
          <span>)</span>
          适用于大救星健康版平台。
        </b>
        <span></span>
      </p>
      <p>
        <b>
          第一部分 定义
          <span></span>
        </b>
      </p>
      <p>
        <b>大救星：</b>
        &nbsp;大救星健康版
        <span>APP (</span>
        域名
        <span>: http://www.dajiuxing.com.cn)</span>
        及官网、
        <span>M</span>
        站、小程序等互联网端口。大救星服务提供者：大救星健康版
        <span>APP</span>
        的互联网信息及软件技术服务提供者江泰救援服务有限公司。
        <span></span>
      </p>
      <p>
        <b>大救星健康版平台：</b>
        指大救星
        <span>(</span>
        域名
        <span>: http://www.dajiuxing.com.cn)</span>
        及大救星健康版客户端、
        <span>M</span>
        站、小程序、救援云官网等互联网端口。
        <span></span>
      </p>
      <p>
        <b>大救星健康版平台服务提供者：</b>
        指大救星健康版平台的互联网信息及软件技术服务提供者江泰救援服务有限公司。
        <span></span>
      </p>
      <p>
        <b>个人信息：</b>
        指以电子或者其他方式记录的能够单独或者与其他信息结合识别特定自然人身份或者反映特定自然人基本介绍情况的各种信息。
        <span></span>
      </p>
      <p>
        <b>运动健康信息：</b>
        包括您在使用我们的智能可穿戴设备（以下简称“设备”）过程中，我们可能收集记录您的运动活动及健康相关信息，包括您的步数、站立活动和时长、运动模式、步频、运动距离、运动时间、心率、血压、心率、血氧饱和度、心跳等信息。除此之外，我们可能收集您的个人相关信息，包括您的性别、生日、身高、体重。
        <span></span>
      </p>
      <p>
        <br />
      </p>
      <p>
        <b>
          个人敏感信息：指包括身份证件号码、用户介绍、行踪轨迹、交易信息等的个人信息及救援服务证明资料
          <span>(</span>
          我们将在本隐私权政策中对具体个人敏感信息以粗体进行显著标识
          <span>)</span>
          。
          <span></span>
        </b>
      </p>
      <p>
        <b>个人信息删除：</b>
        指在实现日常业务功能所涉及的系统中去除个人信息的行为
        <span>,</span>
        使其保持不可被检索、访问的状态。
        <span></span>
      </p>
      <p>
        <b>
          第二部分 本隐私政策将帮助您了解以下内容：
          <span></span>
        </b>
      </p>
      <p>
        一、信息的收集和使用
        <span></span>
      </p>
      <p>
        二、我们如何共享、转让、公开披露您的个人信息
        <span></span>
      </p>
      <p>
        三、我们如何保护和保存您的个人信息
        <span></span>
      </p>
      <p>
        四、您如何管理您的个人信息
        <span></span>
      </p>
      <p>
        五、未成年人的个人信息保护
        <span></span>
      </p>
      <p>
        六、通知和修订
        <span></span>
      </p>
      <p>
        七、如何联系我们
        <span></span>
      </p>
      <p>
        一、信息的收集和使用
        <span></span>
      </p>
      <p>
        <b>
          为本隐私政策之目的，个人信息包括但不限于
          <span>(</span>
          其中
          <span>,</span>
          个人敏感信息以加粗方式显示
          <span>)</span>
          ：
        </b>
        基本信息
        <span>(</span>
        包括
        <b>头像、姓名、性别、年龄、个人邮箱、所在地、个人照片、个人简介</b>
        <span>)</span>
        ；个人身份信息
        <span>(</span>
        包括
        <b>真实姓名、生日、身份证号码</b>
        <span>)</span>
        ；其他信息
        <span>(</span>
        如通讯录、行程信息、网页浏览记录、精准定位信息
        <span>)</span>
        ；
        <span></span>
      </p>
      <p>
        在您使用我们的产品及
        <span>/</span>
        或服务时，我们需要
        <span>/</span>
        可能需要收集和使用的您的个人信息包括如下两种：
        <span></span>
      </p>
      <p>
        <b>1</b>
        <b>
          、为实现向您提供我们产品及
          <span>/</span>
          或服务的基本功能，您须授权我们收集、使用的必要的信息。如您拒绝提供相应信息，您将无法正常使用我们的产品及
          <span>/</span>
          或服务，我们的基本业务功能，包括注册用户服务、在线发起救援服务、查看个人服务权益和保障等基本信息、参加相关奖励活动所必须的功能；
          <span></span>
        </b>
      </p>
      <p>
        <b>2</b>
        <b>
          、为实现向您提供我们产品及
          <span>/</span>
          或服务的附加功能，您可选择授权我们收集、使用的信息。如您拒绝提供，您将无法正常使用相关附加功能或无法达到我们拟达到的功能效果，但并不会影响您正常使用我们产品及
          <span>/</span>
          或服务的基本功能。
          <span></span>
        </b>
      </p>
      <p>
        <b>
          您理解并同意：
          <span></span>
        </b>
      </p>
      <p>
        <b>1</b>
        <b>
          、我们致力于打造为用户提供救援服务或产品以满足您出行在外出现突发状况的需求。因我们向您提供的产品和服务种类众多，且不同用户选择使用的具体产品
          <span>/</span>
          服务范围存在差异，相应地，基本
          <span>/</span>
          附加功能及收集使用的个人信息类型、范围等会有所区别，请以具体的产品
          <span>/</span>
          服务功能为准；
          <span></span>
        </b>
      </p>
      <p>
        <b>2</b>
        <b>
          、为给您带来更好的产品和服务体验，我们在持续努力改进我们的技术，随之我们可能会不时推出新的或优化后的功能，可能需要收集、使用新的个人信息或变更个人信息使用目的或方式。对此，我们将通过更新本隐私政策、以弹窗、页面提示等方式另行向您说明对应信息的收集目的、范围及使用方式，并为您提供自主选择同意的方式，且在征得您明示同意后收集、使用。
          <span></span>
        </b>
      </p>
      <p>
        在此过程中，如果您有任何疑问、意见或建议的，您可在工作日的工作时间（9:00-17:00）通过
        <span>APP</span>
        客服电话
        <span>010-68180898</span>
        与我们联系，我们会尽快为您作出解答。
        <span></span>
      </p>
      <p>
        为本隐私政策之目的，我们仅会出于以下核心业务功能，收集和使用您的个人信息，如果您不提供相关信息，您将无法享受我们提供的产品和
        <span>/</span>
        或服务：
        <span></span>
      </p>
      <p>
        <b>
          （一）帮助您成为我们的注册用户
          <span></span>
        </b>
      </p>
      <p>
        <b>1</b>
        <b>
          、 基础用户服务
          <span></span>
        </b>
      </p>
      <p>
        我们通过大救星账户为您提供基础用户服务。为注册成为用户并使用我们的基础服务，您需要提供
        <b>手机号码</b>
        和
        <b>密码</b>
        用于创建大救星账户。由于大救星健康版属于工具性
        <span>APP</span>
        ，因此内部的一切功能都需要识别个人账号，才能提供精准的服务，所以进入
        <span>APP</span>
        之前必须要注册或者登陆方可计入主页使用。
        <span></span>
      </p>
      <p>
        <b>2</b>
        <b>
          、 附加用户服务
          <span></span>
        </b>
      </p>
      <p>
        实名认证：您可以根据认证要求向我们提供相应的
        <b>身份信息（身份证信息）</b>
        以完成实名认证。获得身份信息的原因在于了解您本人身份信息下有哪些服务正在生效中，身份信息作为唯一服务绑定判定依据。
        <span></span>
      </p>
      <p>
        <b>3</b>
        <b>
          、 账户信息展示：
          <span></span>
        </b>
      </p>
      <p>
        如果您已拥有大救星健康版账户，我们可能会在大救星健康版
        <span>APP</span>
        上显示您的上述个人信息，包括通过大救星健康版
        <span>APP</span>
        集中展示您的个人资料、服务权益。我们会尊重您对大救星服务和大救星健康版账户设置所做的选择。
        <span></span>
      </p>
      <p>
        <b>
          （二）实现信息搜索和展示所必须的功能
          <span></span>
        </b>
      </p>
      <p>
        设备信息：我们会根据您在软件安装及
        <span>/</span>
        或使用中的具体操作，接收并记录您所使用的设备相关信息（包括设备型号、操作系统版本、设备设置、设备环境等软硬件特征信息）、设备所在位置相关信息（包括您授权的
        <span>GPS</span>
        位置以及
        <span>WLAN</span>
        接入点）。
        <span></span>
      </p>
      <p>
        服务日志信息：当您使用我们的网站或客户端提供的产品或服务时，我们会自动收集您对我们服务的详细使用情况，作为服务日志保存，包括浏览、点击查看、搜索查询、收藏、、交易、售后、关注分享信息、发布信息，以及
        <span>IP</span>
        地址、浏览器类型、电信运营商、使用语言、访问日期和时间。
        <span></span>
      </p>
      <p>
        自启动和关联启动：为确保本应用处于关闭或后台运行状态下可正常接收到客户端推送的广播信息，本应用须使用
        <span>(</span>
        自启动
        <span>)</span>
        能力，将存在一定频率通过系统发送广播唤醒本应用自启动或关联启动行为，是因实现功能及服务所必要的。
        <span></span>
      </p>
      <p>
        <b>
          请您注意，如您的搜索关键词信息无法识别您的身份，其将不属于您的个人信息，我们有权在法律法规允许的范围内对其进行自主使用；只有当您的搜索关键词信息单独或与您的其他信息相互结合使用并可以识别您的身份时，则在单独或结合使用期间，我们会将您的搜索关键词信息作为您的个人信息，与您的搜索历史记录一同按照本隐私政策对其进行处理与保护。
          <span></span>
        </b>
      </p>
      <p>
        <b>
          （三）客户服务及争议处理
          <span></span>
        </b>
      </p>
      <p>
        当您需要我们提供客户服务时，我们的客服（包括呼叫中心及在线客服）会使用您的相关信息，如
        <b>账户信息</b>
        。
        <span></span>
      </p>
      <p>
        为保证您的账户安全，我们的呼叫中心客服和在线客服可能会对您的身份进行核验。待您的身份核验后，我们将会为您查询您所需要的相关信息。您有可能会在与我们的客服人员沟通时，提供给出上述信息外的其他信息。
        <span></span>
      </p>
      <p>
        为保障您的合法权益，保证我们的客户服务合法合规，并持续改进我们的客服能力，我们会对您与客服沟通的过程进行录音或文字留存，该留存信息仅会在法律所允许的期限和范围内予以留存和处理，并仅在基于您的维权需要、政府部门及司法部门的调查指令需要提供时，我们会进行必要披露。
        <span></span>
      </p>
      <p>
        为了提供服务及改进服务质量的合理需要，我们还可能使用的您的其他信息，包括您与客服联系时您提供的相关信息，您参与问卷调查时向我们发送的问卷答复信息。
        <span></span>
      </p>
      <p>
        <b>
          （五）您可选择是否授权我们收集和使用您的个人信息的情形
          <span></span>
        </b>
      </p>
      <p>
        1、为使您使用我们的服务更便捷或精准为您提供救援、救助服务，从而提升您在大救星健康版的体验，我们的以下附加功能中会收集和使用您的个人信息。
        <b>
          如果您不提供这些个人信息，会影响使用大救星健康版产品或服务中的核心功能。
        </b>
        <span></span>
      </p>
      <p>
        这些附加功能包括：
        <span></span>
      </p>
      <p>
        （
        <span>1</span>
        ）基于语音技术的附加功能：您可以直接使用麦克风来与我们的客服机器人进行咨询和互动。
        <b>
          在这些功能中我们会处理您的录音内容，以识别您需求和客服与售后需求。
        </b>
        <span></span>
      </p>
      <p>
        （
        <span>2</span>
        ）改进我们的产品与
        <span>/</span>
        或服务：为了提供服务及改进服务质量的合理需要，我们可能会获得的您的其他信息，包括您与客服联系时您提供的相关信息，您参与问卷调查时向我们发送的问卷答复信息，以及您与我们的关联方、我们合作伙伴之间进行互动时授权我们获得的相关信息。
        <span></span>
      </p>
      <p>
        （
        <span>3</span>
        ）我们需要获取手机信息、获取设备信息
        ：通过了解您的设备信息（如设备型号、设备识别码、设备标识符、
        <span>MAC</span>
        地址）、您的网络使用习惯（如浏览信息、常用软件信息）等手段来判断您的账户风险。
        <span></span>
      </p>
      <p>
        （
        <span>4</span>
        ）为识别您的设备并预防恶意程序及反作弊、提高服务安全性、保障运营质量及效率，我们会收集您的设备信息
        <span>(</span>
        <b>
          包括
          <span>IMEI</span>
          、设备序列号、
          <span>OAID</span>
          、
          <span>MEID</span>
          、
          <span>Android ID</span>
          、
          <span>IMSI</span>
          、
          <span>GUID</span>
          、
          <span>MAC</span>
          地址，
          <span>SIM</span>
          卡序列号
        </b>
        <span>)</span>
        、已安装
        <span>APP</span>
        信息或运行中的进程信息。
        <span></span>
      </p>
      <p>
        （
        <span>5</span>
        ）我们通过智能可穿戴设备收集到的运动活动及健康相关信息，包括您的步数、站立活动和时长、运动模式、步频、运动距离、运动时间、心率、血压、心率、血氧饱和度、心跳等信息。除此之外，我们可能收集您的个人相关信息，包括您的性别、生日、身高、体重。
        <span></span>
      </p>
      <p>
        。
        <b><span></span></b>
      </p>
      <p>
        （
        <span>6</span>
        ）我们将要读取应用列表 获取手机中已安装的应用信息
        ：我们的部分服务产品或内容进行支付、分享到第三方平台上时，需要使用唤起您手机中已安装的应用。
        <span></span>
      </p>
      <p>
        （
        <span>7</span>
        ）我们需要获取您手机的存储权限，读写SD卡数据，以便进行数据缓存、文件存储等功能的正常运行。
        <span></span>
      </p>
      <p>
        （
        <span>8</span>
        ）本应用集成了系统 WebView 组件，用于加载网页内容。该组件在启动时会自动探测设备可用的传感器类型（如加速度计、陀螺仪、磁力计等），仅用于优化网页端传感器 API（如 DeviceOrientation、DeviceMotion）的兼容性，‌不会收集、存储、上传或用于用户画像‌。您可在系统设置中随时关闭本应用的传感器权限，以阻止该行为。
        <span></span>
      </p>
      <p>
        2、上述附加功能可能需要您在您的设备中向我们开启您的
        <b>地理位置（位置信息）、相机（摄像头）、相册（图片库）以及麦克风</b>
        访问权限，
        <b>以实现这些功能所涉及的信息的收集和使用</b>
        。您可以在大救星健康版客户端通过“更多
        <span>-&gt;</span>
        权限管理”中逐项查看您上述权限的开启状态，并可以决定将这些权限随时的开启或关闭（我们会指引您在您的设备系统中完成设置）。
        <b>
          请您注意，您开启这些权限即代表您授权我们可以收集和使用这些个人信息来实现上述的功能，您关闭权限即代表您取消了这些授权，则我们将不再继续收集和使用您的这些个人信息，也无法为您提供上述与这些授权所对应的功能。您关闭权限的决定不会影响此前基于您的授权所进行的个人信息的处理。
        </b>
        <span></span>
      </p>
      <p>
        <b>
          （七）您充分知晓，以下情形中，我们收集、使用个人信息可能无需征得您的授权同意：
          <span></span>
        </b>
      </p>
      <p>
        <b>1</b>
        <b>
          、与国家安全、国防安全直接相关的；
          <span></span>
        </b>
      </p>
      <p>
        <b>2</b>
        <b>
          、与公共安全、公共卫生、重大公共利益直接相关的；
          <span></span>
        </b>
      </p>
      <p>
        <b>3</b>
        <b>
          、与犯罪侦查、起诉、审判和判决执行等直接相关的；
          <span></span>
        </b>
      </p>
      <p>
        <b>4</b>
        <b>
          、出于维护您或其他个人的生命、财产等重大合法权益但又很难得到本人同意的；
          <span></span>
        </b>
      </p>
      <p>
        <b>5</b>
        <b>
          、所收集的个人信息是您自行向社会公众公开的；
          <span></span>
        </b>
      </p>
      <p>
        <b>6</b>
        <b>
          、从合法公开披露的信息中收集的您的个人信息的，如合法的新闻报道、政府信息公开等渠道；
          <span></span>
        </b>
      </p>
      <p>
        <b>7</b>
        <b>
          、根据您的要求签订和履行合同所必需的；
          <span></span>
        </b>
      </p>
      <p>
        <b>8</b>
        <b>
          、用于维护所提供的产品与
          <span>/</span>
          或服务的安全稳定运行所必需的，例如发现、处置产品与
          <span>/</span>
          或服务的故障；
          <span></span>
        </b>
      </p>
      <p>
        <b>9</b>
        <b>
          、法律法规规定的其他情形。
          <span></span>
        </b>
      </p>
      <p>
        <b>
          （八）您个人信息使用的规则
          <span></span>
        </b>
      </p>
      <p>
        1、我们会根据本隐私政策的约定，在实现我们的产品与
        <span>/</span>
        或服务功能所必要的范围内，对所收集的个人信息进行使用。
        <span></span>
      </p>
      <p>
        <b>2</b>
        <b>
          、请您注意，您在使用我们的产品与
          <span>/</span>
          或服务时所提供的所有个人信息，除非您删除、通过系统设置或联系我们等方式撤回您的同意，否则将在您使用我们的产品与
          <span>/</span>
          或服务期间持续授权我们使用。在您注销账户时，我们将停止使用并删除您的个人信息。
          <span></span>
        </b>
      </p>
      <p>
        3、我们会对我们的产品与
        <span>/</span>
        或服务使用情况进行统计，并可能会与公众或第三方共享这些统计信息，以展示我们的产品与
        <span>/</span>
        或服务的整体使用趋势。但这些统计信息不包含您的任何身份识别信息。
        <span></span>
      </p>
      <p>
        4、当我们要将您的个人信息用于本隐私政策未载明的其它用途时，或基于特定目的收集而来的信息用于其他目的时，会要求您通过主动勾选的形式事先征求您的同意。
        <span></span>
      </p>
      <p>
        <b>
          二、我们如何共享、转让、公开披露您的个人信息
          <span></span>
        </b>
      </p>
      <p>
        <b>
          （一）共享
          <span></span>
        </b>
      </p>
      <p>
        <b>1</b>
        <b>
          、我们不会与大救星健康版平台以外的任何公司、组织和个人共享您的个人信息，但以下情况除外：
          <span></span>
        </b>
      </p>
      <p>
        <b>
          （
          <span>1</span>
          ）事先获得您明确的同意或授权；
          <span></span>
        </b>
      </p>
      <p>
        <b>
          （
          <span>2</span>
          ）与国家安全、国防安全直接相关的；
          <span></span>
        </b>
      </p>
      <p>
        <b>
          （
          <span>3</span>
          ）与公共安全、公共卫生、重大公共利益直接相关的；
          <span></span>
        </b>
      </p>
      <p>
        <b>
          （
          <span>4</span>
          ）与犯罪侦查、起诉、审判和判决执行等直接相关的；
          <span></span>
        </b>
      </p>
      <p>
        <b>
          （
          <span>5</span>
          ）出于维护个人信息主体或其他个人的生命、财产等重大合法权益但又很难得到本人同意的；
          <span></span>
        </b>
      </p>
      <p>
        <b>
          （
          <span>6</span>
          ）自行向社会公众公开的个人信息；
          <span></span>
        </b>
      </p>
      <p>
        <b>
          （
          <span>7</span>
          ）从合法公开披露的信息中收集个人信息的，如合法的新闻报道、政府信息公开等渠道。
          <span></span>
        </b>
      </p>
      <p>
        <b>2</b>
        <b>
          、经您授权后，我们可能会将您的个人信息与我们的关联方共享。我们只会共享必要的个人信息，并要求关联方以不低于本隐私政策水平的方式保护您的个人信息。我们的关联方如要改变个人信息的处理目的，将再次征求您的授权同意。就上述关联方向您提供的服务，我们对该等关联方提供的服务性质与质量不作任何承诺或承担任何责任，对该等关联方独立进行的用户信息采集和处理行为也不作任何承诺或承担任何责任。有关您在使用关联方服务中相关的隐私控制和选项，以及服务提供者的隐私规定，请您谨慎参阅该等关联方所提供的隐私政策。
          <span></span>
        </b>
      </p>
      <p>
        <b>
          （二）转让与公开披露
          <span></span>
        </b>
      </p>
      <p>
        <b>
          在涉及合并、收购、资产转让或类似的交易时，如涉及到个人信息转让，我们会要求新的持有您个人信息的公司、组织继续受本隐私政策的约束，否则我们将要求该公司、组织重新向您征求授权同意。
          <span></span>
        </b>
      </p>
      <p>
        除本隐私政策所明确述明的情况以外，我们不会将您的个人信息转让或公开披露给任何公司、组织和个人，但以下情况除外：
        <span></span>
      </p>
      <p>
        1、与国家安全、国防安全直接相关的；
        <span></span>
      </p>
      <p>
        2、与公共安全、公共卫生、重大公共利益直接相关的；
        <span></span>
      </p>
      <p>
        3、与犯罪侦查、起诉、审判和判决执行等直接相关的；
        <span></span>
      </p>
      <p>
        4、出于维护您或其他个人的生命、财产等重大合法权益但又很难得到本人同意的；
        <span></span>
      </p>
      <p>
        5、您向社会公众公开的个人信息；
        <span></span>
      </p>
      <p>
        6、从合法公开披露的信息中收集的您的个人信息，如合法的新闻报道、政府信息公开等渠道。
        <span></span>
      </p>
      <p>
        （三）关于第三方插件管理
        <span></span>
      </p>
      <p>
        为了给您提供更专业、安全的核心业务功能和附加业务功能，我们的产品中会接入第三方插件产品（包括在我们的网页或应用程序中部署统计分析工具、软件开发工具包
        <span>SDK</span>
        、调用地图
        <span>API</span>
        接口）。
        <span></span>
      </p>
      <p>
        目前我们
        <span>Android</span>
        系统产品中存在的第三方插件披露如下：
        <span></span>
      </p>
      <p>
        1、腾讯
        <span>IM</span>
        ，即时通讯，文字聊天、语音聊天、发送图片等。
        <span></span>
      </p>
      <p>
        2、阿里智能语音交互（
        <span>nuisdk</span>
        ），语音识别、语音合成，与用户只能交互。
        <span></span>
      </p>
      <p>
        3、百度智能语音技术（
        <span>BaiduSpeech</span>
        ），语音识别、语音合成，与用户只能交互。
        <span></span>
      </p>
      <p>
        4、曲线图、折线图等图表第三方插件（
        <span>MPAndroidChart</span>
        ）。
        <span></span>
      </p>
      <p>
        5、图片查看控件（
        <span>BigImageViewPager</span>
        ），图片点击放大查看等。
        <span></span>
      </p>
      <p>
        <b>
          三、我们如何保护和保存您的个人信息
          <a name="_GoBack"></a>
          <span></span>
        </b>
      </p>
      <p>
        <b>
          （一）我们保护您个人信息的技术与措施
          <span></span>
        </b>
      </p>
      <p>
        我们非常重视个人信息安全，并采取一切合理可行的措施，保护您的个人信息：
        <span></span>
      </p>
      <p>
        1、 数据安全技术措施
        <span></span>
      </p>
      <p>
        大救星健康版采取安全技术和管理措施来防止您的个人信息遭到未经授权访问使用、公开披露、使用、修改、损坏或丢失，包括但不限于：
        <span></span>
      </p>
      <p>
        （
        <span>1</span>
        ）大救星健康版采取严格的数据访问权限控制和多重身份认证技术保护个人信息，避免数据被违规使用；
        <span></span>
      </p>
      <p>
        （
        <span>2</span>
        ）大救星健康版采取数据访问日志分析技术进行个人信息安全审计。
        <span></span>
      </p>
      <p>
        2、 大救星健康版为保护个人信息采取的其他安全措施
        <span></span>
      </p>
      <p>
        安全制度保障。大救星健康版发布了《数据安全管理制度》和《个人信息保护指引》，通过制度规范大救星健康版各部门对个人信息所采取的管理措施。
        <span></span>
      </p>
      <p>
        加强安全意识。我们还会举办安全和隐私保护培训课程，加强员工对于保护个人信息重要性的认识。
        <span></span>
      </p>
      <p>
        3、
        我们建议您使用电子邮件、即时通讯、社交软件等与其他用户的交流工具时请使用复杂密码，并注意保护您的个人信息安全。
        <span></span>
      </p>
      <p>
        4、
        我们将尽力确保您发送给我们的任何信息的安全性。如果我们的物理、技术、或管理防护设施遭到破坏，信息被非授权访问、公开披露、篡改、或毁坏，导致您的合法权益受损，我们将承担相应的法律责任。
        <span></span>
      </p>
      <p>
        5、 安全事件处置
        <span></span>
      </p>
      <p>
        为应对个人信息泄露、损毁和丢失的风险，大救星健康版制定了多项制度并成立了应急响应团队。我们按照安全事件的处置规范，针对不同安全事件启动安全预案，进行止损、分析、定位、制定补救措施、联合相关部门进行溯源和打击。
        在不幸发生个人信息安全事件后，我们将按照法律法规的要求，及时向您告知：安全事件的基本情况和可能的影响、我们已采取或将要采取的处置措施、您可自主防范和降低风险的建议、对您的补救措施等。我们将及时将事件相关情况以邮件、信函、电话、推送通知等方式告知您，难以逐一告知个人信息主体时，我们会采取合理、有效的方式发布公告。同时，我们还将按照监管部门要求，主动上报个人信息安全事件的处置情况。
        <span></span>
      </p>
      <p>
        6、
        如果您发现自己的个人信息泄密或我们存在有安全弱点、可疑安全事件时，尤其是您的账户及密码发生泄露，请您立即通过本隐私政策最下方约定的联系方式联络我们，以便我们采取相应措施，禁止私自尝试或验证弱点。
        <span></span>
      </p>
      <p>
        7、
        如果您对我们的个人信息保护有任何疑问，可通过本隐私政策最下方约定的联系方式联系我们。
        <span></span>
      </p>
      <p>
        <b>
          （二）您个人信息的保存
          <span></span>
        </b>
      </p>
      <p>
        1、原则上，我们在中华人民共和国境内收集和产生的个人信息，将存储在中华人民共和国境内。由于我们通过遍布全球的资源和服务器提供产品或服务，这意味着，在获得您对本协议的授权同意后，您的个人信息可能会被转移到您使用产品或服务所在国家
        <span>/</span>
        地区的境外管辖区，或者受到来自这些管辖区的访问。此类管辖区可能设有不同的数据保护法，甚至未设立相关法律。在此类情况下，我们会确保您的个人信息得到在中华人民共和国境内足够同等的保护。
        <span></span>
      </p>
      <p>
        2、当您成功申请注销大救星健康版账户后，我们将在您提出申请的
        <span>48</span>
        小时内完成对您的账户注销审核，审核通过后，我们将对您的个人信息进行删除或匿名化处理。
        <span></span>
      </p>
      <p>
        <b>3</b>
        <b>
          、如果我们终止服务或运营，我们会至少提前三十日向您通知，并在终止服务或运营后对您的个人信息进行删除或匿名化处理。
          <span></span>
        </b>
      </p>
      <p>
        <b>
          四、您如何管理您的个人信息
          <span></span>
        </b>
      </p>
      <p>
        大救星健康版非常重视您对个人信息的关注，并尽全力保护您对于您个人信息访问、更正、删除以及撤回同意的权利，以使您拥有充分的能力保障您的隐私和安全。您的权利包括：
        <span></span>
      </p>
      <p>
        <b>1</b>
        <b>
          、访问和更正您的个人信息
          <span></span>
        </b>
      </p>
      <p>
        除法律法规规定外，您有权随时访问和更正您的个人信息，具体包括：
        <span></span>
      </p>
      <p>
        （
        <span>1</span>
        ）您的账户信息： 您可以在大救星健康版移动端
        <span>App</span>
        访问您的个人信息；具体路径为：“我的”进入我的个人中心
        <span>--</span>
        点击“我的证件”按钮进入查看。
        <span></span>
      </p>
      <p>
        （
        <span>2</span>
        ）对于您在使用我们的产品与
        <span>/</span>
        或服务过程中产生的其他个人信息需要访问或更正，请随时联系我们。我们会根据本隐私政策所列明的方式和期限响应您的请求。
        <span></span>
      </p>
      <p>
        <b>2</b>
        <b>
          、删除您的个人信息
          <span></span>
        </b>
      </p>
      <p>
        您在我们的产品与
        <span>/</span>
        或服务页面中可以直接清除或删除的信息。
        <span></span>
      </p>
      <p>
        在以下情形中，您可以向我们提出删除个人信息的请求：
        <span></span>
      </p>
      <p>
        （
        <span>1</span>
        ）如果我们处理个人信息的行为违反法律法规；
        <span></span>
      </p>
      <p>
        （
        <span>2</span>
        ）如果我们收集、使用您的个人信息，却未征得您的同意；
        <span></span>
      </p>
      <p>
        （
        <span>3</span>
        ）如果我们处理个人信息的行为违反了与您的约定；
        <span></span>
      </p>
      <p>
        （
        <span>4</span>
        ）如果您注销了大救星健康版账户；
        <span></span>
      </p>
      <p>
        （
        <span>5</span>
        ）如果我们终止服务及运营。
        <span></span>
      </p>
      <p>
        若我们决定响应您的删除请求，我们还将同时通知从我们获得您的个人信息的实体，要求其及时删除，除非法律法规另有规定，或这些实体获得您的独立授权。
        <span></span>
      </p>
      <p>
        当您从我们的服务中删除信息后，我们可能不会立即备份系统中删除相应的信息，但会在备份更新时删除这些信息。
        <span></span>
      </p>
      <p>
        <b>3</b>
        <b>
          、改变您授权同意的范围或撤回您的授权
          <span></span>
        </b>
      </p>
      <p>
        <b>
          您可以通过删除信息、关闭设备功能、在大救星健康版软件中进行隐私设置等方式改变您授权我们继续收集个人信息的范围或撤回您的授权。您也可以通过注销账户的方式，撤回我们继续收集、处理您个人信息的全部授权。
          <span></span>
        </b>
      </p>
      <p>
        <b>
          请您理解，每个业务功能需要一些基本的个人信息才能得以完成，当您撤回同意或授权后，我们无法继续为您提供撤回同意或授权所对应的服务，也不再处理您相应的个人信息。但您撤回同意或授权的决定，不会影响此前基于您的授权而开展的个人信息处理。
          <span></span>
        </b>
      </p>
      <p>
        <b>4</b>
        <b>
          、响应您的请求
          <span></span>
        </b>
      </p>
      <p>
        如果您无法通过上述方式访问、更正或删除您的个人信息，或您需要访问、更正或删除您在使用我们产品与
        <span>/</span>
        或服务时所产生的其他个人信息，或您认为大救星健康版存在任何违反法律法规或与您关于个人信息的收集或使用的约定，您均可以发送电子邮件至
        <span>ops@dajiuxing.com.cn</span>
        或通过本协议下方的其他方式与我们联系。
        <span></span>
      </p>
      <p>
        为了保障安全，我们可能需要您提供书面请求，或以其他方式证明您的身份，我们将在收到您反馈并验证您的身份后的十五（
        <span>15</span>
        ）天内答复您的请求。对于您合理的请求，我们原则上不收取费用，但对多次重复、超出合理限度的请求，我们将视情收取一定成本费用。对于那些无端重复、需要过多技术手段（例如，需要开发新系统或从根本上改变现行惯例）、给他人合法权益带来风险或者非常不切实际（例如，涉及备份磁带上存放的信息）的请求，我们可能会予以拒绝。
        <span></span>
      </p>
      <p>
        <b>
          在以下情形中，按照法律法规要求，我们将可能无法响应您的请求：
          <span></span>
        </b>
      </p>
      <p>
        <b>
          （
          <span>1</span>
          ）与国家安全、国防安全直接相关的；
          <span></span>
        </b>
      </p>
      <p>
        <b>
          （
          <span>2</span>
          ）与公共安全、公共卫生、重大公共利益直接相关的；
          <span></span>
        </b>
      </p>
      <p>
        <b>
          （
          <span>3</span>
          ）与犯罪侦查、起诉、审判和执行判决等直接相关的；
          <span></span>
        </b>
      </p>
      <p>
        <b>
          （
          <span>4</span>
          ）有充分证据表明您存在主观恶意或滥用权利的；
          <span></span>
        </b>
      </p>
      <p>
        <b>
          （
          <span>5</span>
          ）响应您的请求将导致您或其他个人、组织的合法权益受到严重损害的；
          <span></span>
        </b>
      </p>
      <p>
        <b>
          （
          <span>6</span>
          ）涉及商业秘密的。
          <span></span>
        </b>
      </p>
      <p>
        <b>
          五、未成年人的个人信息保护
          <span></span>
        </b>
      </p>
      <p>
        1、大救星健康版非常重视对未成年人个人信息的保护。您若是
        <span>18</span>
        周岁以下的未成年人，则无法使用我们的产品与
        <span>/</span>
        或服务。大救星健康版根据国家相关法律法规的规定保护未成年人的个人信息。
        <span></span>
      </p>
      <p>
        2、我们如果发现自己在未事先获得可证实的父母或法定监护人同意的情况下收集了未成年人的个人信息，则会设法尽快删除相关数据。
        <span></span>
      </p>
      <p>
        <b>
          六、通知和修订
          <span></span>
        </b>
      </p>
      <p>
        1、为给您提供更好的服务以及随着大救星业务的发展，本隐私政策也会随之更新。但未经您明确同意，我们不会削减您依据本隐私政策所应享有的权利。我们会通过在大救星健康版移动端
        <span>APP</span>
        上发出更新版本并在生效前通过短信公告或以其他适当方式提醒您相关内容的更新，也请您访问大救星健康版以便及时了解最新的隐私政策。
        <span></span>
      </p>
      <p>
        2、对于重大变更，我们还会提供更为显著的通知（我们会通过包括但不限于邮件、短信或在浏览页面做特别提示等方式，说明隐私政策的具体变更内容）。
        <span></span>
      </p>
      <p>
        <b>
          本隐私政策所指的重大变更包括但不限于：
          <span></span>
        </b>
      </p>
      <p>
        <b>
          （
          <span>1</span>
          ）我们的服务模式发生重大变化。如处理个人信息的目的、处理的个人信息类型、个人信息的使用方式等；
          <span></span>
        </b>
      </p>
      <p>
        <b>
          （
          <span>2</span>
          ）我们在所有权结构、组织架构等方面发生重大变化。如业务调整、破产并购等引起的所有者变更等；
          <span></span>
        </b>
      </p>
      <p>
        <b>
          （
          <span>3</span>
          ）个人信息共享、转让或公开披露的主要对象发生变化；
          <span></span>
        </b>
      </p>
      <p>
        <b>
          （
          <span>4</span>
          ）您参与个人信息处理方面的权利及其行使方式发生重大变化；
          <span></span>
        </b>
      </p>
      <p>
        <b>
          （
          <span>5</span>
          ）我们负责处理个人信息安全的责任部门、联络方式及投诉渠道发生变化时；
          <span></span>
        </b>
      </p>
      <p>
        <b>
          （
          <span>6</span>
          ）个人信息安全影响评估报告表明存在高风险时。
          <span></span>
        </b>
      </p>
      <p>
        3、我们还会将本策略的旧版本存档，供您查阅。
        <span></span>
      </p>
      <p>
        <b>
          七、如何联系我们
          <span></span>
        </b>
      </p>
      <p>
        1、如您对本隐私政策或您个人信息的相关事宜有任何问题、意见或建议，请通过发送邮件至
        <span>ops@dajiuxing.com.cn</span>
        或拨打我们的客服电话（
        <span>010-68180898</span>
        ）等多种方式与我们联系。
        <span></span>
      </p>
      <p>
        2、我们设立了个人信息保护专职部门（或个人信息保护专员），您可以通过发送邮件至
        <span>ops@dajiuxing.com.cn</span>
        的方式与其联系。
        <span></span>
      </p>
      <p>
        3、一般情况下，我们将在十五（
        <span>15</span>
        ）天内回复。如果您对我们的回复不满意，特别是我们的个人信息处理行为损害了您的合法权益，您还可以向网信、电信、公安及工商等监管部门进行投诉或举报，或者向有管辖权的法院提起诉讼。
        <span></span>
      </p>
      <p>
        <b>
          我们谨此再次提醒您，本隐私政策内容中以加粗方式显著标识的条款，请您着重阅读。您点击“注册”
          <span>/</span>
          “登录”按钮即视为您完全接受本隐私政策，在点击之前请您再次确认已知悉并完全理解本隐私政策的全部内容。
          <span></span>
        </b>
      </p>
      <p class="MsoNormal">
        <span></span>
      </p>
    </div>
  </div>
</template>
<script>
import { mapState } from 'pinia';
import { useGlobalStore } from '@/stores/global';

export default {
  name: 'agreement',
  computed: {
    ...mapState(useGlobalStore, ['statusBarHeight'])
  },
  data() {
    return {}
  },
  mounted() {
    document.title = '隐私条款'
  },
  methods: {
    /**
     * 微信小程序环境返回上一页
     */
    goBackMiniProgram() {
      this.$router.go(-1);
    },
  },
}
</script>
<style lang="less" scoped>
::-webkit-scrollbar-track {
  width: 0 !important;
  background-color: transparent !important; /* 设置滚动条追踪区的背景色为透明 */
}
@supports (
    (height: constant(safe-area-inset-top)) or
      (height: env(safe-area-inset-top))
  )
  and (-webkit-overflow-scrolling: touch) {
  body {
    /* 适配齐刘海 */
    padding-top: 20px;
    padding-top: constant(safe-area-inset-top);
    padding-top: env(safe-area-inset-top);

    /* 适配底部小黑条 */
    padding-bottom: 0;
    padding-bottom: costant(safe-area-inset-bottom);
    padding-bottom: env(safe-area-inset-bottom);
  }
}
.agreement {
  width: 100%;
  height: 100vh;
  display: flex;
  flex-direction: column;
  background: #fff;
  .mp-back-btn-fixed-left {
    position: fixed;
    left: 12px;
    z-index: 9999;
    width: 36px;
    height: 36px;
    border-radius: 18px;
    border: 1px solid rgba(0, 0, 0, 0.08);
    background: rgba(255, 255, 255, 0.95);
    box-shadow: 0 6px 16px rgba(0, 0, 0, 0.08);
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 0;
  }
  .main {
    width: 100%;
    flex: 1;
    height: auto;
    overflow-y: scroll;
    padding: 3.15vh 4vw;
    h2 {
      font-size: 4vw;
      text-align: center;
      margin-bottom: 2vw;
    }
    h3,
    p {
      font-size: 3.5vw;
      line-height: 6vw;
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/views/agreement.vue